import { render, staticRenderFns } from "./PrivacyPolicyComponent.vue?vue&type=template&id=54a736ee&"
import script from "./PrivacyPolicyComponent.vue?vue&type=script&lang=ts&"
export * from "./PrivacyPolicyComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports